<template>
    <v-container fluid>   
      <LeftMenu/>     
        <v-layout row wrap>   
          <v-flex xs1></v-flex>
          <v-flex xs10>
            <v-data-table
              :headers="headers"
              :items="roles"
              :items-per-page="50"
              item-key="id"
              sort-by="user"
              class="elevation-1"
              show-expand
              :search="search"
              :custom-filter="filterOnlyCapsText"
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Roles - Menu Items</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="900px">
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">New Role</v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12 sm6 md6>
                              <v-text-field v-model="editedItem.code" label="Role Code"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field v-model="editedItem.text" label="Role Name"></v-text-field>
                            </v-flex>                                                                                                                                                                     
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <v-dialog v-model="menuItemDialog" max-width="300px">                    
                    <v-card>
                      <v-card-title>
                        <span class="headline">Add Menu Item</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>                                      
                            <v-flex xs12 sm6 md6>   
                              <v-combobox
                                :items="menuItems"
                                label="Select Menu Item"
                                v-model="editedMenuItem"
                                item-text="title"
                                single-line
                                return-object
                              ></v-combobox>                         
                            </v-flex>                                                                                                                                                                                     
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="closeMenuItemDialog">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="saveMenuItem">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                </v-toolbar>
                <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
              </template> 
              <template v-slot:expanded-item="{ headers, item: masterItem }">
                <td :colspan="headers.length" >                  
                  <v-layout row wrap>   
                    <v-flex xs12/>
                    <v-flex xs3>
                      Menu Items of {{ masterItem.text }}                    
                    </v-flex>
                    <v-flex xs9>                       
                    </v-flex>
                    <v-flex xs12>


                      <v-data-table
                      :headers="menuItemsHeaders"
                      :items="masterItem.menuItems"
                      :items-per-page="20"
                      item-key="id"
                      sort-by="transfersDate"
                      :sort-desc=true
                      class="elevation-1"
                      >                      
                      <template v-slot:body.append>                    
                      </template>             
                      <template v-slot:item.menuItemAction="{ item }">              
                        <v-icon                  
                          @click="deleteMenuItemRecord(item,masterItem)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>

                    </v-flex>
                  </v-layout>
                </td>                
              </template>
              <template v-slot:body.append>                    
              </template>           
              <template v-slot:item.addMenuItem="{ item }">              
                <v-icon                  
                  @click="addMenuItem(item)">
                  mdi-plus-circle-outline
                </v-icon>               
              </template>   
              <template v-slot:item.action="{ item }">              
                <v-icon                  
                  @click="editItem(item)">
                  mdi-table-edit
                </v-icon>
                
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs1></v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import LeftMenu from '../../components/LeftMenu';
const ROLE_API_URL = 'roles';
const MENU_ITEMS_API_URL = 'definitions/menuItems';
export default {
    components:{
      LeftMenu
    },
    data () {
    return {
      dialog: false,
      menuItemDialog : false,
      editedItemRole: {},
      editedMenuItem : { title:''},
      search: '',
      roles: [],
      menuItems: [],
      editedIndex: -1,
      editedItem: {
        model: '',
          name: '',
          surname: '',
          email: '', 
      },
      defaultItem: {
        model: '',
          name: '',
          surname: '',
          email: '', 
      },
    }
  },
  computed: {
    headers () {
      return [
        { text: 'Add Menu Item',  value: 'addMenuItem'  },    
        { text: 'RoleCode',  value: 'code'  },
        { text: 'Role Name',  value: 'text'  },   
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },
    menuItemsHeaders () {
      return [
        { text: 'Menu Item',  value: 'title'  },        
        { text: 'Item Actions', value: 'menuItemAction', sortable: false },
      ]
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New User' : 'Edit User'
    },
  },
  created() {    
    this.getRoles();
    this.getMenuItems();
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  methods: {
    addMenuItem(item){ 
      this.editedItemRole = Object.assign({}, item)
      this.menuItemDialog = true
    }, 
    closeMenuItemDialog(){
      this.menuItemDialog = false
    },
    saveMenuItem(){
      if(this.editedMenuItem){
        this.$axios.post(this.$apiurl + ROLE_API_URL+'/addnew/'+this.editedItemRole.id+'/'+this.editedMenuItem.id, {})
        .then(response => {        
          if (response.status === 201) {
            this.getRoles();
            this.closeMenuItemDialog();
          } 
        }) 
        .catch(error => {
          console.log(error);
        }); 
      }
    },
    editItem (item) {
      this.editedIndex = this.roles.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.roles.indexOf(item)
      if(confirm('Are you sure you want to delete this user?')){
        this.roles.splice(index, 1);
        this.deleteUser(item);
      } 
    },
    deleteMenuItemRecord (item, masterItem) {
      console.log(item);
      console.log(masterItem);
      const index = masterItem.menuItems.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        masterItem.menuItems.splice(index, 1);
        this.deleteMenuItem(item,masterItem);
      } 
    },
    deleteMenuItem(item, masterItem){
      this.$axios.delete(this.$apiurl + 'roles/'+masterItem.id+'/menuItems/'+item.id)
      .then(response => {
        if (response.status === 200) {
          this.getUsers();
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {        
        this.updateRole(this.editedItem);
      } else {
        this.addRole(this.editedItem);         
      }      
    },
    addRole(item){
      this.$axios.post(this.$apiurl + ROLE_API_URL, {
        code: item.code,
        text: item.text,
      })
      .then(response => {        
        if (response.status === 201) {
          this.getRoles();
          this.close();
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    updateRole(item){
      this.$axios.put(this.$apiurl + ROLE_API_URL, {
        id: item.id,
        code: item.code,
        text: item.text,
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.roles[this.editedIndex], this.editedItem);
          this.close();
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    deleteRole(item){
      this.$axios.delete(this.$apiurl + ROLE_API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getMenuItems(){     
        this.$axios.get(this.$apiurl + MENU_ITEMS_API_URL)
            .then(response => {
                this.menuItems = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getRoles(){     
        this.$axios.get(this.$apiurl + ROLE_API_URL + "/all")
            .then(response => {
                this.roles = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
